module.exports = __webpack_public_path__ + "static/media/imgop_ComicImage.fa755f13.png";